// extracted by mini-css-extract-plugin
export var $animation_name = "ProductCategory-module--$animation_name--182b9";
export var ProductCategoryHeader = "ProductCategory-module--ProductCategoryHeader--4643e";
export var ProductCategoryHeaderContent = "ProductCategory-module--ProductCategoryHeaderContent--08887";
export var ProductCategoryHeader__quantity = "ProductCategory-module--ProductCategoryHeader__quantity--68629";